import createSvgIcon from "./utils/create_icon"

const CopyOutline = createSvgIcon(<><path d="M3 5a2 2 0 0 1 2-2h11a1 1 0 1 1 0 2H5v11a1 1 0 1 1-2 0V5z" clipRule="evenodd" fill="currentColor" fillRule="evenodd" /><path d="M7 9a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2V9zm12 0H9v10h10V9z" clipRule="evenodd" fill="currentColor" fillRule="evenodd" /></>, "CopyOutline")
export default CopyOutline
